import layoutMap from "./layoutMap";

const LayoutHandler = layout => {
  const Layout = layoutMap(layout);

  return Layout;
};

export default LayoutHandler;
